import { useEffect } from "react";

/**
 * Update <title> and the meta[name=description] tag when a route mounts.
 * Helps search engines and browser UI reflect route-specific context in the SPA.
 */
export const usePageMeta = ({ title, description }) => {
    useEffect(() => {
        if (title) document.title = title;
        if (description) {
            let tag = document.querySelector('meta[name="description"]');
            if (!tag) {
                tag = document.createElement("meta");
                tag.setAttribute("name", "description");
                document.head.appendChild(tag);
            }
            tag.setAttribute("content", description);
        }
    }, [title, description]);
};
